import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  scrollBehavior() {
    return {x: 0, y: 0};
  },
  routes: [{
      path: '/',
      name: 'home',
      index:1,
      component: () => import('./views/Home.vue')
    },
    {
      path: '/Pt',
      name: 'Pt',
      index:2,
      component: () => import('./views/Pt.vue'),
    },
    {
      path: '/sjbz',
      name: 'sjbz',
      index:2,
      component: () => import('./views/sjbz.vue'),
    },
    {
      path: '/sjcj',
      name: 'sjcj',
      index:2,
      component: () => import('./views/sjcj.vue'),
    },
    {
      path:'/dsjsjmx',
      name:'dsjsjmx',
      component:()=>import('./views/dsjsjmx.vue')
    },
    {
      path:'/cpsjj',
      name:'cpsjj',
      component:()=>import('./views/cpsjj.vue')
    },
    {
      path:'/zxsjj',
      name:'zxsjj',
      component:()=>import('./views/zxsjj.vue')
    },
    {
      path:'/znjs',
      name:'znjs',
      component:()=>import('./views/znjs.vue')
    },
    {
      path:'/znyl',
      name:'znyl',
      component:()=>import('./views/znyl.vue')
    },
    // {
    //   path:'/qych',
    //   name:'qych',
    //   component:()=>import('./views/qych.vue')
    // },
    {
      path:'/hlw',
      name:'hlw',
      component:()=>import('./views/hlw.vue')
    },
    {
      path:'/znzd',
      name:'znzd',
      component:()=>import('./views/znzd.vue')
    },
    {
      path:'/dzsw',
      name:'dzsw',
      component:()=>import('./views/dzsw.vue')
    },
    // {
    //   path:'/bzjd',
    //   name:'bzjd',
    //   component:()=>import('./views/bzjd.vue')
    // },
    {
      path:'/rcpx',
      name:'rcpx',
      component:()=>import('./views/rcpx.vue')
    },
    {
      path:'/callMe',
      name:'callMe',
      component:()=>import('./views/callMe.vue')
    },
    {
      path:'/zbpt',
      name:'zbpt',
      component:()=>import('./views/zbpt.vue')
    },
    {
      path:'/xwdt',
      name:'xwdt',
      component:()=>import('./views/xwdt.vue')
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default kejianrouter
